import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Card, Row, Col, Tooltip, Spin } from "antd";
import { CalendarOutlined, FileTextOutlined, SolutionOutlined } from "@ant-design/icons";
import { AuthContext } from "../../context/AuthProviderWrapper";
import { usePeriodAvailability } from "../../../hooks/usePeriodAvailability";

function ChooseDeclarationType() {
  const { activeCompany } = useContext(AuthContext);
  const navigate = useNavigate();
  const {
    hasAnyMonthlyAvailable,
    hasAnySemiAnnualAvailable,
    hasAnyAnnualAvailable,
    periodsLoading,
  } = usePeriodAvailability();

  const infoAlertContent = (
    <div>
      <p>
        <b>Choisissez le type de déclaration :</b>
        <br />
        <br />
        <b>Déclaration mensuelle : </b>
        Pour déclarer les salaires du mois en cours ou des mois précédents.
        <br />
        <br />
        <b>Déclaration semestrielle : </b>
        Pour déclarer les salaires d'un semestre complet.
        <br />
        <br />
        <b>Déclaration annuelle : </b>
        Pour régulariser une année complète lorsqu'aucune déclaration mensuelle n'a été effectuée.
      </p>
    </div>
  );

  const declarationTypes = [
    {
      title: "Déclaration mensuelle",
      description: "Déclarez les salaires du mois",
      icon: <CalendarOutlined style={{ fontSize: "48px", color: "#1890ff" }} />,
      route: "/declaration",
      isAvailable: hasAnyMonthlyAvailable(),
      disabledMessage: "Aucune période mensuelle disponible pour cette entreprise adhérente",
    },
    {
      title: "Déclaration semestrielle",
      description: "Déclarez les salaires d'un semestre",
      icon: <FileTextOutlined style={{ fontSize: "48px", color: "#52c41a" }} />,
      route: "/semi-annual-declaration",
      isAvailable: hasAnySemiAnnualAvailable(),
      disabledMessage: "Aucune période semestrielle disponible pour cette entreprise adhérente",
    },
    {
      title: "Déclaration annuelle",
      description: "Régularisation pour une année complète",
      icon: <SolutionOutlined style={{ fontSize: "48px", color: "#faad14" }} />,
      route: "/annual-declaration",
      isAvailable: hasAnyAnnualAvailable(),
      disabledMessage: "Aucune année disponible pour une régularisation annuelle",
    },
  ];

  if (periodsLoading) {
    return (
      <div className="block-right" style={{ textAlign: "center", padding: "50px" }}>
        <Spin size="large" tip="Chargement des périodes disponibles..." />
      </div>
    );
  }

  return (
    <div className="block-right">
      <Alert
        message={infoAlertContent}
        type="info"
        showIcon
        style={{ alignItems: "center", margin: "auto", width: "100%" }}
      />

      <Row gutter={[24, 24]} style={{ marginTop: "40px", padding: "0 20px" }}>
        {declarationTypes.map((type, index) => {
          const cardContent = (
            <Card
              hoverable={type.isAvailable}
              onClick={type.isAvailable ? () => navigate(type.route) : undefined}
              style={{
                textAlign: "center",
                height: "100%",
                minHeight: "250px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                opacity: type.isAvailable ? 1 : 0.5,
                cursor: type.isAvailable ? "pointer" : "not-allowed",
                backgroundColor: type.isAvailable ? "white" : "#f5f5f5",
              }}
            >
              <div style={{ marginBottom: "20px" }}>{type.icon}</div>
              <Card.Meta
                title={<h3 style={{ marginBottom: "10px" }}>{type.title}</h3>}
                description={
                  <p style={{ fontSize: "14px", color: "#666" }}>
                    {type.description}
                  </p>
                }
              />
            </Card>
          );

          return (
            <Col xs={24} md={8} key={index}>
              {!type.isAvailable ? (
                <Tooltip title={type.disabledMessage} placement="top">
                  {cardContent}
                </Tooltip>
              ) : (
                cardContent
              )}
            </Col>
          );
        })}
      </Row>
    </div>
  );
}

export default ChooseDeclarationType;
